import { BaseDataItem, Sharpness } from '@wix/thunderbolt-becky-types'
import { createGlobalImagQualityRef, GlobalImageQualityViewItem } from './globalImageQualityPlanner'
import { createPlanner } from './typeResolverUtils'

type PartialImageDataItem = BaseDataItem<'Image'> & { quality?: Sharpness }

export const imagePlanner = createPlanner<
	PartialImageDataItem,
	PartialImageDataItem & { globalQuality?: GlobalImageQualityViewItem }
>(
	(dataItem) => {
		if (dataItem.quality && Object.keys(dataItem.quality).length) {
			return dataItem
		}

		return {
			...dataItem,
			globalQuality: createGlobalImagQualityRef(),
		}
	},
	({ globalQuality, ...dataItem }) => {
		if (!globalQuality) {
			return dataItem
		}

		return { ...dataItem, quality: globalQuality }
	}
)
